declare global {
	interface Window {
		gtag: (...args: any[]) => void
	}
}

export const logGoogleAdsEvent = (eventName: 'purchase' | 'checkout' | 'generateEssay' | 'upgradeModal') => {
	const eventNameToConversionId = {
		purchase: '-huLCILJpMAaEJjWocA_',
		checkout: 'C8YHCNydpcAaEJjWocA_',
		generateEssay: '38gQCI_RtsAaEJjWocA_',
		upgradeModal: 'Oo5TCM_Mn8QaEJjWocA_',
	}

	if (window.gtag) {
		window.gtag('event', 'conversion', {
			send_to: 'AW-17046203160/' + eventNameToConversionId[eventName],
			event_callback: () => {},
		})
	} else {
		console.error('Google Tag Manager is not initialized.')
	}
}
